import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

/** Code-barres de la remise de scan : Code 39 (lu par les scans), dessiné en
 * SVG sur fond blanc (lisible même en thème sombre). Code 39 : chiffres,
 * majuscules, espace et - . $ / + % seulement. */
export function CodeBarre({ valeur, hauteur = 70, largeur = 2, texte = true, className = "", testId }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current || !valeur) return;
    try {
      JsBarcode(ref.current, String(valeur).toUpperCase(), { format: "CODE39", width: largeur, height: hauteur, displayValue: texte, fontSize: 16, margin: 10, background: "#ffffff", lineColor: "#000000" });
    } catch { /* caractère non encodable */ }
  }, [valeur, hauteur, largeur, texte]);
  if (!valeur) return null;
  return <svg ref={ref} className={`max-w-full h-auto rounded bg-white ${className}`} data-testid={testId} />;
}
